import { RouteConfigProvider } from '@/context/route-config';
import FcaQuestionnaireForm, { type FcaQuestionnaireRouteConfig } from '@/features/onboarding/fca-questionnaire/components/form';
import FcaQuestionnaireLayout from '@/features/onboarding/fca-questionnaire/layout';

const ROUTE_CONFIG = {
  ineligible: '/onboarding/fca-questionnaire/ineligible',
  next: '/onboarding/verification',
  personalInformation: '/onboarding/personal-information',
} satisfies FcaQuestionnaireRouteConfig;

const FcaQuestionnairePage = () => {
  return (
    <FcaQuestionnaireLayout>
      <RouteConfigProvider config={ROUTE_CONFIG}>
        <FcaQuestionnaireForm />
      </RouteConfigProvider>
    </FcaQuestionnaireLayout>
  );
};
FcaQuestionnairePage.displayName = 'FcaQuestionnairePage';

export default FcaQuestionnairePage;
